export function StatusBadge({ status, overdue }) {
  const map = {
    overdue: "bg-[rgba(239,68,68,0.12)] text-[#FCA5A5] border-[rgba(239,68,68,0.3)]",
    awaiting_client: "bg-[rgba(245,158,11,0.12)] text-[#FCD34D] border-[rgba(245,158,11,0.3)]",
    to_review: "bg-[rgba(59,130,246,0.12)] text-[#93C5FD] border-[rgba(59,130,246,0.3)]",
    completed: "bg-[rgba(16,185,129,0.12)] text-[#6EE7B7] border-[rgba(16,185,129,0.3)]",
    upcoming: "bg-white/5 text-slate-300 border-[#1E294B]",
    due: "bg-[rgba(245,158,11,0.12)] text-[#FCD34D] border-[rgba(245,158,11,0.3)]",
    paid: "bg-[rgba(16,185,129,0.12)] text-[#6EE7B7] border-[rgba(16,185,129,0.3)]",
    open: "bg-[rgba(245,158,11,0.12)] text-[#FCD34D] border-[rgba(245,158,11,0.3)]",
  };
  const labels = {
    awaiting_client: "Awaiting client", to_review: "To review", completed: "Completed",
    upcoming: "Upcoming", overdue: "Overdue", due: "Due", paid: "Paid", open: "Open",
  };
  const key = overdue ? "overdue" : status;
  return (
    <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium border ${map[key] || map.upcoming}`}>
      {labels[key] || status}
    </span>
  );
}

export function SectionTitle({ children, action }) {
  return (
    <div className="flex items-center justify-between mb-4 mt-2">
      <h2 className="font-serif font-bold text-xl md:text-2xl text-white">{children}</h2>
      {action}
    </div>
  );
}

export function EmptyState({ icon: Icon, title, hint }) {
  return (
    <div className="card-surface rounded-2xl p-10 text-center">
      {Icon && <Icon className="mx-auto text-slate-600 mb-3" size={36} />}
      <p className="text-white font-medium">{title}</p>
      {hint && <p className="text-slate-500 text-sm mt-1">{hint}</p>}
    </div>
  );
}

export function Modal({ open, onClose, title, children, wide }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[90] bg-black/70 backdrop-blur-sm flex items-start md:items-center justify-center p-4 overflow-y-auto" onClick={onClose}>
      <div className={`card-surface rounded-2xl p-6 w-full ${wide ? "max-w-2xl" : "max-w-lg"} my-8`} onClick={(e) => e.stopPropagation()}>
        {title && <h3 className="font-serif font-bold text-xl text-white mb-4">{title}</h3>}
        {children}
      </div>
    </div>
  );
}
